import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DoneIcon from '@mui/icons-material/Done';
import DeleteIcon from '@mui/icons-material/Delete';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Chip": Chip, "@mui/material/Stack": Stack, "@mui/icons-material/Done": DoneIcon, "@mui/icons-material/Delete": DeleteIcon } } });
export default ClientProvider;
